var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-gray-300 rounded-sm relative",class:{ 'animate-pulse': _vm.total <= 0 }},[_c('div',{staticClass:"brand-blue absolute top-0 left-0 bottom-0",style:({ width: _vm.progress })})])
}
var staticRenderFns = []

export { render, staticRenderFns }